<template>
  <div class="chance">
    <div class="home-content">
      <!-- 推荐 -->
      <div class="home-t">
        <div class="home-t-newLeft" v-for="(item,index) in chanceTypeList.slice(0,3)" :key="index">
          <div class="header">{{item.name}}</div>
          <!-- 数量最多13个 -->
          <template v-if="item.list.items.length">
            <div v-for="(itm,idx) in item.list.items.slice(0,13)" :key="idx" class="matter" @click="linkToChance(itm)">
              <span :title="itm.information">{{itm.information}}</span>
              <span>{{itm.inTime | moment('YYYY/MM/DD')}}</span>
            </div>
          </template>
          <div v-else style="text-align:center;line-height:100px;">暂无数据！</div>
          <div class="seeMore" @click="$router.push('/chance-type?id=' + item.id + '&name=' + item.name)">查看更多</div>
        </div>

        <!-- <div class="home-t-left">
            <h2 class="home-title">推荐商机</h2>
            <div class="chance-list" v-if="chanceList.length">
                <div class="chance-list-one" 
                v-for="(itme,index) in chanceList.slice(0,8)" 
                :key="index" 
                :class="index > 3 ? 'three' : ''"
                @click="linkToChance(itme)"
                >
                    <div class="one-top">
                        <img :src="itme.headImg" alt="" v-if="itme.headImg">
                        <img src="@/assets/img/empty.png" alt="" v-else>
                        <p>{{itme.title}}</p>
                    </div>
                    <div class="one-bot">
                        <p>
                            <span class="time">{{itme.inTime | moment('YYYY/MM/DD')}}</span>
                            <span class="view">
                              <i class="icon iconfont icon-zhiboguankanshu"></i>
                              {{itme.viewCount > 9999 ? (Math.floor(itme.viewCount/1000)/10) + 'W' :itme.viewCount}}
                            </span>
                        </p>
                        <div class="one-list-img"  v-if="itme.photo.length">
                            <div class="img" v-for="(item,index) in itme.photo" :key="index">
                              <img :src="item" alt="" v-if="item">
                              <img src="@/assets/img/empty.png" alt="" v-else>
                            </div>
                        </div>
                        <h3 :title="itme.information">{{ itme.photo.length == 0 ? (itme.information.length > 58 ? itme.information.slice(0,58) + '...' : itme.information) 
                          : (itme.photo.length > 3 ? (itme.information.length > 18 ? itme.information.slice(0,18) + '...' : itme.information) : (itme.information.length > 40 ? itme.information.slice(0,40) + '...' : itme.information))}}</h3>
                    </div>
                </div>
            </div>
            <div class="no-msg" v-else>
                暂无数据！
            </div>
        </div> -->
        <div class="home-t-right">
          <exRelease :newChanceList="newChanceList" @finish="getChanceList"></exRelease>
        </div>
      </div>
      <!-- 品牌企业 -->
      <div class="home-c-brand">
        <h2>品牌企业</h2>
        <brandCard></brandCard>
      </div>
      <!-- 所有商机 -->
      <!-- <div class="home-b-chance">
        <h2>全部商机</h2>
        <div class="chance-list" v-if="chanceList.length">
            <div class="chance-list-one" 
            v-for="(itme,index) in chanceList" 
            :key="index"
            @click="linkToChance(itme)"
            >
                <div class="one-top">
                    <img :src="itme.headImg" alt="" v-if="itme.headImg">
                    <img src="@/assets/img/empty.png" alt="" v-else>
                    <p>{{itme.title}}</p>
                </div>
                <div class="one-bot">
                    <p>
                        <span class="time">{{itme.inTime | moment('YYYY/MM/DD')}}</span>
                        <span class="view">
                          <i class="icon iconfont icon-zhiboguankanshu"></i>
                         {{itme.viewCount > 9999 ? (Math.floor(itme.viewCount/1000)/10) + 'W' :itme.viewCount}}
                        </span>
                    </p>
                    <div class="one-list-img"  v-if="itme.photo.length">
                        <div class="img" v-for="(item,index) in itme.photo" :key="index">
                          <img :src="item" alt="" v-if="item">
                          <img src="@/assets/img/empty.png" alt="" v-else>
                        </div>
                    </div>
                    <h3 :title="itme.information">{{ itme.photo.length == 0 ? (itme.information.length > 58 ? itme.information.slice(0,58) + '...' : itme.information) 
                          : (itme.photo.length > 3 ? (itme.information.length > 18 ? itme.information.slice(0,18) + '...' : itme.information) : (itme.information.length > 40 ? itme.information.slice(0,40) + '...' : itme.information))}}</h3>
                </div>
            </div>
            <div class="more">
              <div class="more f-csp" v-if="donetTip"> 
                <span>没有更多了</span> 
              </div>
              <div class="more f-csp" @click="loadList()" v-else> 
                <span>加载更多</span> 
              </div> 
            </div>
        </div>
        <div class="no-msg" v-else>
            暂无数据！
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
// import swiperCommon from "@components/swiper-common";
import exRelease from "./ex-release";
import brandCard from "./brand-card";
import { mapActions, mapGetters, mapMutations } from "vuex";


export default {
  name: "chance",
  data() {
    return {
      chanceList: [], //商机列表
      pageIndex: 1,
      pageSize: 18, // 一页18条；
      donetTip:false,
      newChanceList:[], // 最新商机
      chanceTypeList: []
    };
  },
  components: {
    // swiperCommon, 
    exRelease,
    brandCard
  },
  computed: { 
    ...mapGetters({
      exhibitionId:'getExhibitionId'
    }),
  },
  created() {
    this.getChanceList();
    // this.getNewChanceList();
  },
  methods: {
    ...mapActions({
      getReleaseType: "exhibitor/getReleaseType"
    }),
    async getChanceList() {
      let body = {
        exhibitionId:this.exhibitionId,
        top: 20
      };
      let arr = [];
      let list = await this.getReleaseType(body);
      if (list && list.length) {
        list.map(c => {
          if (c.list && c.list.items.length) {
            c.list.items.map(d => {
              arr.push(d)
            })
          }
        })
        this.chanceTypeList = list;
      } else {
        this.chanceTypeList = [];
      }

      if (arr.length) {
        const pages = [];
        list = arr.slice(0,9);
        list.forEach((e, i) => {
          const c = Math.floor(i / 3);
          if (!pages[c]) {
            pages[c] = [];
          }
          pages[c].push(e);
        });
        this.newChanceList = pages; 
      }
      // console.log("商机列表：",chanceTypeList);
    },
    async getNewChanceList() {
      let body = {
        ExhibitionId:this.exhibitionId,
        pageSize: this.pageSize,
        pageIndex: this.pageIndex,
      };
      let list = await this.$service.getExChanceAllList(this,body);
        let arr = [];
        list.map(c => {
          if (c.statusId === 1) {
            arr.push(c);
          }
        })
        const pages = [];
        list = arr.slice(0,9);
        list.forEach((e, i) => {
          const c = Math.floor(i / 3);
          if (!pages[c]) {
            pages[c] = [];
          }
          pages[c].push(e);
        });
        this.newChanceList = pages;
    },
    loadList() {
       this.pageIndex ++;
       this.getChanceList();
    },
    linkToChance(item) {
      const url = location.origin + `/chance-detail?chanceId=${item.id}`;
      window.open(url, "_blank");
      // this.$router.push(`/chance-detail?chanceId=${item.id}`);
    }
  },
};
</script>

<style scoped lang='scss'>
.chance{
  background: #f5f5f5;
}
.home-content{
    margin-top: 20px;
    width: 1200px;
    margin: 0 auto 90px;
    .home-t{
        display: flex;
    }

    .home-t-newLeft {
      margin-right: 20px;
      width: 255px;
      height: 566px;
      background: #fff;
      color: #333;
      position: relative;
      .header {
        width: 100%;
        height: 48px;
        background-color: #024c8b;
        text-align: center;
        color: #fff;
        font-size: 16px;
        line-height: 3;
      }
      .matter {
        margin-top: 15px;
        padding-left: 10px;
        display: flex;
        cursor: pointer;
        span {
          display: inline-block;
        }
        span:first-child {
          width: calc(100% - 80px);
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
        }
        span:last-child {
          color: #666;
        }
      }
      .seeMore {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        line-height: 46px;
        text-align: center;
        color: #999;
        cursor: pointer;
      }
    }

    .home-t-left{
        margin-right: 20px;
        width: 804px;
        background: #fff;
        padding:20px;
        height: 566px;
    }
}
.home-title{
    font-size: 16px;
	font-weight: bold;
	line-height: 18px;
	color: #333;
    margin-bottom: 20px;
}
.chance-list{
    display: flex;
    flex-wrap: wrap;
    &-one{
        width: 176px;
        height: 234px;
        border: solid 1px #f2f2f2;
        margin: 0 20px 20px 0;
        overflow: hidden;
        cursor: pointer;
        .one-top{
            display: flex;
            align-items: center;
            padding:10px;
            height: 40px;
            border-bottom: 1px solid #f2f2f2;
            img{
                width: 20px;
	            height: 20px;
                border-radius: 3px;
                display: block;
                margin-right: 10px;
                border: solid 1px #e5e5e5;
            }
            p{
                width: 110px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
        .one-bot{
            padding:10px;
            p{
                display: flex;
                align-items: center;
                justify-content: space-between;
                font-size: 12px;
                color:#666;
                line-height: 14px;
                margin-bottom: 10px;
                .view{
                    display: flex;
                    align-items: center;
                    i{
                      margin-right: 2px;
                    }
                }
            }
            .one-list-img{
                display: flex;
                flex-wrap: wrap;
                .img{
                    width:50px;
                    height: 50px;
                    margin:0 2px 3px 0;
                    img{
                        width: 100%;
                        height: 100%;
                    }
                }
                .img:nth-child(3n+3){
                  margin-right:0;
                }
            }
            h3{
              font-size: 14px;
              line-height: 24px;
              color:#333;
            }
        }
    }
    .three{
      margin-bottom: 0;
    }
}
.home-t-left{
  .chance-list-one:nth-child(4n+4){
      margin:0 0 20px 0;  
  }
}
.home-c-brand{
  margin-top: 20px;
  background: #fff;
  padding:15px 0 ;
  h2{
    font-size: 16px;
    font-weight: bold;
    line-height: 26px;
    color: #333;
    text-align: center;
    padding:0 15px ;
  }
}
.home-b-chance{
  margin-top: 20px;
  background: #fff;
  padding:15px 22px;
  h2{
    font-size: 16px;
    font-weight: bold;
    line-height: 26px;
    color: #333;
    text-align: center;
    padding-bottom: 15px;
  }
}
.home-b-chance{
  .chance-list-one:nth-child(6n+6){
     margin:0 0 20px 0;  
  }
}
.no-msg{
    font-size: 14px;
    color: #666;
    text-align: center;
    padding:100px 0;
}
.more{
  height: 80px;
  line-height: 80px!important;
  text-align: center;
  width: 100%;
  display: table;
  font-size: 12px!important;
}
</style>